<div class="actions">
  <div class="actions__actions">
    <button class="secondary" (click)="acaoSalvar.emit()">Salvar</button>
    <button *ngIf="exibeAcaoInativar" class="secondary" (click)="acaoAtivarInativar.emit()">
      {{ descricaoBotaoStatus }}
    </button>
    <button class="primary" (click)="acaoVoltar.emit()">Voltar</button>
  </div>
</div>
